import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateParser, TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

@Injectable()
export class MyMatPaginatorIntl extends MatPaginatorIntl {
    private rangeLabelIntl: string;

    constructor(
        private translateService: TranslateService,
        private translateParser: TranslateParser,
    ) {
        super();
        this.getTranslations();
    }

    getTranslations(): void {
        this.translateService.get(['common.paginator.itemsPerPage', 'common.paginator.nextPage', 'common.paginator.previousPage', 'common.paginator.range']).subscribe((t) => {
            this.itemsPerPageLabel = t['common.paginator.itemsPerPage'];
            this.nextPageLabel = t['common.paginator.nextPage'];
            this.previousPageLabel = t['common.paginator.previousPage'];
            this.rangeLabelIntl = t['common.paginator.range'];
            this.lastPageLabel = t['common.paginator.lastPageLabel'];
            this.firstPageLabel = t['common.paginator.firstPageLabel'];
            this.changes.next();
        });
    }

    getRangeLabel = (page: number, pageSize: number, length: number): string => {
        if (length === 0 || pageSize === 0) {
            return `0 / ${length}`;
        }

        const workingLength = Math.max(length, 0);

        const startIndex = page * pageSize;

        const endIndex = startIndex < workingLength ? Math.min(startIndex + pageSize, workingLength) : startIndex + pageSize;

        return `${startIndex + 1} - ${endIndex} / ${workingLength}`;
    };
}
